export const DUE_DATE_UNITS = ["minutes", "hours", "days"] as const;
export type DueDateUnit = (typeof DUE_DATE_UNITS)[number];

export type DueDateInput =
  | { mode: "exact"; date: Date }
  | { mode: "relative"; amount: number; unit: DueDateUnit; from?: Date };

const UNIT_TO_MS: Record<DueDateUnit, number> = {
  minutes: 60 * 1000,
  hours: 60 * 60 * 1000,
  days: 24 * 60 * 60 * 1000,
};

/**
 * Resolves a due-date input to an absolute Date, once. Relative mode is
 * computed from `from` (defaults to now) at the moment this is called —
 * callers must call this at save time, not render time, and must never
 * persist the relative expression itself (see functions-v2's
 * automationActionExpireAt/StartAt for the existing precedent this mirrors).
 */
export function resolveDueDate(input: DueDateInput): Date {
  if (input.mode === "exact") {
    return input.date;
  }

  if (input.amount < 0) {
    throw new Error("resolveDueDate: relative amount must be non-negative");
  }

  const from = input.from ?? new Date();
  return new Date(from.getTime() + input.amount * UNIT_TO_MS[input.unit]);
}
